export default () =>
  import(/* webpackChunkName: 'coffee/activities/new-bie/home' */ './Home');
